import PropTypes from 'prop-types';
import React, {useEffect, useMemo, useRef} from 'react';
import {MAPBOX_DARK} from '../../config.js';
import {Map, TileLayer, VectorLayer} from '@planet/layers';
import {featureStyle} from '../review-common.jsx';
import {getExtentForGeometry} from '../../util/map.js';
import {styled} from '@mui/material';
import {transformExtent} from 'ol/proj';

const MapParent = styled('div')(({theme}) => ({
  position: 'absolute',
  top: theme.spacing(1),
  left: theme.spacing(1),
  width: `calc(100% - ${theme.spacing(1)})`,
  height: `calc(100% - ${theme.spacing(1)})`,
  margin: 0,
  overflow: 'hidden',
  borderRadius: '20px',
  backgroundColor: theme.palette.grey[600],
}));

export const InsetMap = ({basemap, detect, feed, onClick, view}) => {
  const mapRef = useRef();

  const detectStyle = useMemo(() => featureStyle(feed), [feed]);

  // zoom to the feature
  useEffect(() => {
    if (mapRef.current && detect) {
      const extent = transformExtent(
        getExtentForGeometry(detect.geometry),
        'EPSG:4326',
        'EPSG:3857',
      );
      const view = mapRef.current.getView();
      view.fit(extent, {
        // TODO: Make the padding a prop.
        padding: [40, 40, 40, 40],
        maxZoom: 16,
      });
    }
  }, [detect]);

  return (
    <MapParent>
      <Map
        innerRef={node => (mapRef.current = node)}
        animation={{duration: 300}}
        constructorOptions={{view}}
        style={{
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          position: 'absolute',
          cursor: onClick !== undefined ? 'pointer' : 'default',
        }}
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}
      >
        <TileLayer url={MAPBOX_DARK} />
        {basemap && <TileLayer url={basemap._links.tiles} />}
        {detect && <VectorLayer data={detect} layerStyle={detectStyle} />}
      </Map>
    </MapParent>
  );
};

InsetMap.propTypes = {
  basemap: PropTypes.object,
  detect: PropTypes.object,
  feed: PropTypes.object,
  onClick: PropTypes.func,
  view: PropTypes.object.isRequired,
};
